const API = process.env.REACT_APP_API_URL;

// ================= SIGNUP =================
export const registerUser = async (data) => {
  const res = await fetch(`${API}/auth/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await res.json();

  if (!res.ok) {
    throw new Error(result.error || "Signup failed");
  }

  return result;
};

// ================= LOGIN =================
export const loginUser = async (data) => {
  const res = await fetch(`${API}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await res.json();

  if (!res.ok) {
    throw new Error(result.error || "Login failed");
  }

  return result;
};

// ================= GET PRODUCTS =================
export const getProducts = async () => {
  const res = await fetch(`${API}/products`);
  const result = await res.json();

  if (!res.ok) {
    throw new Error(result.error || "Failed to fetch products");
  }

  return result;
};